import { createRouter, createWebHistory } from "vue-router";
import Tables from "../views/Tables.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Guard from '../services/middleware';
import DashboardLayout from "../../src/layout/DashboardLayout";

//Site
import Home from "../views/Site/Home.vue";
import CursoDestaque from "../views/Site/CursoDestaque.vue";
import formCurso from "../views/Site/formCurso.vue";
import Cadastro from "../views/Site/Cadastro.vue";
import CadastroPessoa from "../views/Site/CadastroPessoa.vue";
import CadastroEntrevistaSocial from "../views/Site/CadastroEntrevistaSocial.vue";
import CadastroRealizado from "../views/Site/CadastroRealizado.vue";
import Apoiador from "../views/Site/Apoiador.vue";
import Associado from "../views/Site/Associado.vue";
import Agradecimento from "../views/Site/Agradecimento.vue";
import PagCurso from "../views/Site/PagCurso.vue";
import Teste from "../views/Site/Teste.vue";
import TermosDeUso from "../views/Site/TermosDeUso.vue";
import CadastroCancelado from "../views/Site/CadastroCancelado.vue";
import Finalizar from "../views/Site/Finalizar.vue";
//Dashboard

//Painel
import LoginPainel from "../views/Painel/Login.vue";
import Dashboard from "../views/Painel/Dashboard.vue";
import Usuarios from "../views/Painel/Usuarios.vue";
import CadastrarUsusario from "../views/Painel/CadastrarUsusario.vue";
import Pacientes from "../views/Painel/Pacientes.vue";
import DispensaOleos from "../views/Painel/DispensaOleos.vue";
import VisualizarPaciente from "../views/Painel/VisualizarPaciente.vue";
import Pets from "../views/Painel/Pets.vue";
import EntrevistaSocialAdm from "../views/Painel/EntrevistaSocialAdm.vue";
import VisualizarEntrevista from "../views/Painel/VisualizarEntrevista.vue";
import ProfissionalSaude from "../views/Painel/ProfissionalSaude.vue";
import VisualizarProfissional from "../views/Painel/VisualizarProfissional.vue";
import Medicos from "../views/Painel/Medicos.vue";
import CadastrarMedico from "../views/Painel/CadastrarMedico.vue";
import Patologias from "../views/Painel/Patologias.vue";
import CadastrarPatologia from "../views/Painel/CadastrarPatologia.vue";
import TiposOleo from "../views/Painel/TiposOleo.vue";
import CadastrarTipoOleo from "../views/Painel/CadastrarTipoOleo.vue";
import EstoqueOleo from "../views/Painel/EstoqueOleo.vue";
import Relatorios from "../views/Painel/Relatorios.vue";

import Videos from "../views/Painel/Videos.vue";
import CadastrarVideo from "../views/Painel/CadastrarVideo.vue";
import CadastrarDepoimento from "../views/Painel/CadastrarDepoimento.vue";
import Timbres from "../views/Painel/Timbres.vue";
import NewsLetter from "../views/Painel/NewsLetter.vue";
import CadastrarNewsLetter from "../views/Painel/CadastrarNewsLetter.vue";
import Empresa from "../views/Painel/Empresa.vue";
import Contatos from "../views/Painel/Contatos.vue";
import VisualizarContato from "../views/Painel/VisualizarContato.vue";
import Depoimentos from '../views/Painel/Depoimentos.vue';
import CadastrarTimbre from "../views/Painel/CadastrarTimbre.vue";

const routes = [

  {
    path: "/",
    name: "home",
    components: { default: Home },
  },
  {
    path: "/teste",
    name: "Teste",
    components: { default: Teste },
  },

  {
    path: "/atendimento",
    name: "atendimento",
    components: { default: Associado },
  },
  {
    path: "/curso-destaque/:id",
    name: "destaqueCurso",
    components: { default: CursoDestaque },
  },
  {
    path: "/inscricao-curso/:id",
    name: "formCurso",
    components: { default: formCurso },
  },
  {
    path: "/pag-curso",
    name: "pagCurso",
    components: { default: PagCurso },
  },
  {
    path: "/cadastrar/:tipo_cadastro",
    name: "cadastroTipo",
    components: { default: Cadastro },
  },
  {
    path: "/cadastro/:tipo_pessoa",
    name: "cadastroPessoa",
    components: { default: CadastroPessoa },
  },
  {
    path: "/cadastro-entrevista-social",
    name: "EntrevistaSocial",
    components: { default: CadastroEntrevistaSocial },
  },
  {
    path: "/cadastro-realizado",
    name: "cadastroRealizado",
    components: { default: CadastroRealizado },
  },
  {
    path: "/doe/:tipo_pagina",
    name: "apoiador",
    components: { default: Apoiador },
  },
  {
    path: "/agradecimento",
    name: "agradecimento",
    components: { default: Agradecimento },
  },
  {
    path: "/termos-de-responsabilidade",
    name: "TermosDeUso",
    components: { default: TermosDeUso },
  },
  {
    path: "/cadastro-cancelado",
    name: "CadastroCancelado",
    components: { default: CadastroCancelado },
  },
  {
    path: "/finalizacao",
    name: "Finalizar",
    components: { default: Finalizar },
  },


   {
      path: "/admin/login",
      name: "LoginPainel",
      component: LoginPainel,
   },

            {
            path: "/admin/cadastrar-timbre",
            name: "CadastrarTimbre",
            components: { default: CadastrarTimbre },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/alterar-timbre/:id",
            name: "AlterarTimbre",
            components: { default: CadastrarTimbre },
            beforeEnter: Guard.auth
         },
   {
      path: "/admin",
      redirect: "/admin/dashboard",
      component: DashboardLayout,
      children: [

         {
            path: "/admin/dashboard",
            name: "dashboard",
            components: { default: Dashboard },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/cadastrar-depoimentos",
            name: "CadastrarDepoimento",
            components: { default: CadastrarDepoimento },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/alterar-depoimentos/:id",
            name: "AlterarDepoimento",
            components: { default: CadastrarDepoimento },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/tables",
            name: "Tables",
            components: { default: Tables },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/virtual-reality",
            name: "Virtual Reality",
            components: { default: VirtualReality },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/rtl-page",
            name: "RTL",
            components: { default: RTL },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/usuarios",
            name: "Usuarios",
            components: { default: Usuarios },
            beforeEnter: Guard.auth
         },
               {
        path: "/admin/cadastrar-patologia",
        name: "CadastrarPatologia",
        components: { default: CadastrarPatologia },
        beforeEnter: Guard.auth
      },
               {
        path: "/admin/dispensa-oleo/:id",
        name: "DispensaOleos",
        components: { default: DispensaOleos },
        beforeEnter: Guard.auth
      },
         {
            path: "/admin/pacientes",
            name: "pacientes",
            components: { default: Pacientes },
            beforeEnter: Guard.auth
         },
               {
        path: "/admin/cadastrar-paciente",
        name: "cadastrarPaciente",
        components: { default: VisualizarPaciente },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/visualizar-paciente/:id",
        name: "visualizarPaciente",
        components: { default: VisualizarPaciente },
        beforeEnter: Guard.auth

         },
            {
        path: "/admin/pets",
        name: "pets",
        components: { default: Pets },
        beforeEnter: Guard.auth
         },
            {
        path: "/admin/entrevista-social",
        name: "EntrevistaSocialAdm",
        components: { default: EntrevistaSocialAdm },
        beforeEnter: Guard.auth
         },
            {
        path: "/admin/visualizar-entrevista-social/:id",
        name: "VisualizarEntrevista",
        components: { default: VisualizarEntrevista },
        beforeEnter: Guard.auth
         },
      
{
        path: "/admin/cooperadores",
        name: "profissionalSaude",
        components: { default: ProfissionalSaude },
        beforeEnter: Guard.auth
      },

      {
        path: "/admin/visualizar-cooperador/:id",
        name: "VisualizarCooperrador",
        components: { default: VisualizarProfissional },
        beforeEnter: Guard.auth
         },
            {
        path: "/admin/medicos",
        name: "medicos",
        components: { default: Medicos },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/cadastrar-medico",
        name: "cadastrarMedico",
        components: { default: CadastrarMedico },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/visualizar-medico/:id",
        name: "visualizarMedico",
        components: { default: CadastrarMedico },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/patologias",
        name: "patologias",
        components: { default: Patologias },
        beforeEnter: Guard.auth

      },
      {
        path: "/admin/visualizar-patologia/:id",
        name: "visualizarPatologia",
        components: { default: CadastrarPatologia },
        beforeEnter: Guard.auth
         },
      
               {
        path: "/admin/tipos-oleos",
        name: "tipoOleo",
        components: { default: TiposOleo },
        beforeEnter: Guard.auth

      },


      {
        path: "/admin/cadastrar-tipo-oleo",
        name: "CadastrarTipoOleo",
        components: { default: CadastrarTipoOleo },
        beforeEnter: Guard.auth
      },

      {
        path: "/admin/tipos-oleos/:id/estoque",
        name: "estoqueOleo",
        components: { default: EstoqueOleo },
        beforeEnter: Guard.auth
      },

      {
        path: "/admin/visualizar-tipo-oleo/:id",
        name: "visualizarTipoOleo",
        components: { default: CadastrarTipoOleo },
        beforeEnter: Guard.auth
         },
      
               {
        path: "/admin/relatorios",
        name: "relatorios",
        components: { default: Relatorios },
        beforeEnter: Guard.auth
      },

         {
            path: "/admin/alterar-usuario/:id",
            name: "AlterarUsusario",
            components: { default: CadastrarUsusario },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/cadastrar-usuario",
            name: "CadastrarUsuario",
            components: { default: CadastrarUsusario },
            beforeEnter: Guard.auth
         },

         {
            path: "/admin/depoimentos",
            name: "Depoimentos",
            components: { default: Depoimentos },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/videos",
            name: "Videos",
            components: { default: Videos },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/cadastrar-video",
            name: "CadastrarVideo",
            components: { default: CadastrarVideo },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/alterar-video/:id",
            name: "AlterarVideo",
            components: { default: CadastrarVideo },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/timbres",
            name: "Timbres",
            components: { default: Timbres },
            beforeEnter: Guard.auth
         },

         {
            path: "/admin/news-letter",
            name: "NewsLetter",
            components: { default: NewsLetter },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/cadastrar-new-latter",
            name: "CadastrarNewsLetter",
            components: { default: CadastrarNewsLetter },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/alterar-new-latter/:id",
            name: "AlterarNew",
            components: { default: CadastrarNewsLetter },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/empresa",
            name: "Empresa",
            components: { default: Empresa },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/contatos",
            name: "Contatos",
            components: { default: Contatos },
            beforeEnter: Guard.auth
         },
         {
            path: "/admin/visualzar-contato/:id",
            name: "VisualizarContato",
            components: { default: VisualizarContato },
            beforeEnter: Guard.auth
         },
      ]
   },
   {
      path: "/:pathMatch(.*)*",
      redirect: "/",
   },

];

const router = createRouter({
   history: createWebHistory(process.env.BASE_URL),
   routes,
   linkActiveClass: "active",
});

export default router;
